module.exports = __webpack_public_path__ + "img/FAA_STEM AVSED_Logo_v5_Logo.f7383aff.png";